export default __webpack_public_path__ + "static/media/AMSTs.6fc69754.png";